import { render, staticRenderFns } from "./WasteExchangeSearchView.vue?vue&type=template&id=5c50484d&scoped=true"
import script from "./WasteExchangeSearchView.vue?vue&type=script&lang=js"
export * from "./WasteExchangeSearchView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c50484d",
  null
  
)

export default component.exports